// built-from: /client-auth-session v1 impl:client-auth-session role:implementation
// Browser-session auth flag for the shared-secret login gate. Backed by
// sessionStorage so the "authenticated" state survives a re-render / route
// change but clears when the tab closes. Only a flag is stored — never the
// password the user typed.
//
// 093: alongside the flag it now remembers the name the person signed in with,
// so context items and filed pages can say who added them. Still no credential.

const AUTH_KEY = 'arcpilot.authed';
const NAME_KEY = 'arcpilot.username';

export function isAuthed(): boolean {
  try {
    return window.sessionStorage.getItem(AUTH_KEY) === '1';
  } catch {
    return false;
  }
}

export function setAuthed(username?: string): void {
  try {
    window.sessionStorage.setItem(AUTH_KEY, '1');
    const name = (username || '').trim();
    if (name) window.sessionStorage.setItem(NAME_KEY, name);
    else window.sessionStorage.removeItem(NAME_KEY);
  } catch {
    /* sessionStorage unavailable — treat as not authed */
  }
}

// The name to show against work this person adds. Empty when nobody signed in,
// or when they signed in without giving one.
export function getUsername(): string {
  try {
    return window.sessionStorage.getItem(NAME_KEY) || '';
  } catch {
    return '';
  }
}

export function clearAuthed(): void {
  try {
    window.sessionStorage.removeItem(AUTH_KEY);
    window.sessionStorage.removeItem(NAME_KEY);
  } catch {
    /* sessionStorage unavailable — nothing to clear */
  }
}
